module.exports = __webpack_public_path__ + "img/scan.9c0e0a28.svg";